module.exports = __webpack_public_path__ + "media/images/icons/dots-v-d6a17b24fd05df945d4e8b01dc3a80a9.svg";